import { useState, useEffect } from 'react';
import { Article } from '@/types/article';
import { getArticleBySlug } from '@/services/articleService';

export const useArticle = (slug?: string, domainId?: string) => {
  const [article, setArticle] = useState<Article | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticle = async () => {
      if (!slug) {
        setError('Article not found');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        const articleData = await getArticleBySlug(slug, domainId);
        
        if (!articleData) {
          setError('Article not found');
          setIsLoading(false);
          return;
        }

        setArticle(articleData);
      } catch (err) {
        console.error('Error fetching article:', err);
        setError('Failed to load article. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [slug, domainId]);

  return { article, isLoading, error };
}; 